

import useTranslations from "../../providers/useTranslations";

function ServiceAddonItem(props) {

  const { addon, detailColour, formatPrice } = props

  const onIncrease = (addon) => {
    if (addon.max > 0 && addon.quantity >= addon.max) {
      //console.log("ServiceAddonItem onIncrease exceeded max", addon)
    } else {
      props.onIncrease(addon)
    }
  }

  const onDecrease = (addon) => {
    if (addon.quantity > 0) {
      props.onDecrease(addon)
    }
  }

  return (
    <div className="service-addon-item service-grid-addon-item" >
      <div className="service-addon-item-top"
        style={
          {
            backgroundColor: detailColour,
          }
        }

      >
        <div className="valign-middle">
          {addon.name}
        </div>
        <div className="valign-middle">
          + {formatPrice(addon.price)}
        </div>
      </div>

      <div className="service-addon-item-bottom centrar" >
        <span className="addon-modifier col-4 centrar" style={{ fontSize: "28px", padding: 0, paddingLeft: "15px" }}
          onClick={() => {
            onDecrease(addon)
          }}   >
          {addon.quantity > 0 ? '-' : ''}
        </span>
        <span className="col-4 centrar" style={{ fontSize: "20px", padding: 0, paddingLeft: "10px" }}>
          {addon.quantity || 0}
        </span>
        <span className=" addon-modifier col-4 centrar" style={{ fontSize: "25px", padding: 0, paddingLeft: "10px" }}
          onClick={() => {
            onIncrease(addon)
          }} >
          +
        </span>

      </div>
    </div>


  )
}

function ServiceAddonSelector(props) {
  const { addonSelected, service, addons, formatPrice } = props

  const { tr } = useTranslations();

  let selectedAddons = service.selectedAddons || []

  if (service.maxAddons && service.maxAddons > 0) {
    let sum = selectedAddons.reduce((sum, a) => sum + a.quantity, 0)

    if (sum >= service.maxAddons) {
      return <></>
    }
  }

  let newAddons = addons.filter((addon) => !selectedAddons.find((selected) => selected.id === addon.id)  )

  if (newAddons.length === 0) return <></>

  return <select style={{
    width: '95%'
  }}
    onChange={(event) => {
      addonSelected(event.target.value)
    }} >
    <option>{tr("Select addons")}</option>
    {newAddons.map((a, index) =>

      <option key={"s_" + service.id + "_addon" + a.id + index} value={a.id}
        style={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      > {a.name} + {formatPrice(a.price)}
      </option>
    )
    }
  </select>
}

export default function ServiceAddons(props) {
  const { service, formatPrice } = props;

  const [showAddons, setShowAddons] =React.useState(true)

  const _selectedAddon = (service, addon) => {
    let selectedAddons = service.selectedAddons || []
    let found = selectedAddons.find((a) => a.name === addon.name)

    return found || addon
  }

  if (!service.Addons || service.Addons.length == 0)
    return (<div></div>)

  const breakpointColumnsObj = {
    default: 5,
    900: 4,
    700: 3,
    500: 2
  };

  const selectedAddonsGrid = (addons) => {
    if (!addons || addons.length == 0) return <></>

    return (
      <div className="service-item-grid">

        {addons.filter((a) => a.quantity > 0).map((c) =>
          <ServiceAddonItem
            key={"s_" + service.id + "_addon" + c.id}
            service={service} addon={_selectedAddon(service, c)}
            onIncrease={props.onIncrease}
            onDecrease={props.onDecrease}
            detailColour={props.detailColour}
            formatPrice={formatPrice}
          />
        )
        }

      </div>
    )
  }

  const _addonsContent = (addons) => {

    if (!addons || addons.length == 0 || !showAddons) {
      return <></>
    }
    if (addons.length > 4) {
      return <div>

        {selectedAddonsGrid(service.selectedAddons)}

        <ServiceAddonSelector service={service}
          addons={addons}
          addonSelected={(id) => {
            props.onIncrease(addons.find((addon) => addon.id == id))
          }}
          formatPrice={formatPrice}
           />
      </div>
    }

    return (
      <div className="service-item-grid">

        {addons.map((c) =>
          <ServiceAddonItem
            key={"s_" + service.id + "_addon" + c.id}
            service={service} addon={_selectedAddon(service, c)}
            onIncrease={props.onIncrease}
            onDecrease={props.onDecrease}
            detailColour={props.detailColour}
            formatPrice={formatPrice}
          />
        )
        }

      </div>
    )
  }

  return (
    <div className="service-addons service-options">

      {service.addonsTitle && service.addonsTitle.length > 0
        ?
        <h5 style={{ margin: "10px" }}>{service.addonsTitle}</h5>
        : <h5 style={{ margin: "10px" }}> Adicionales</h5>
      }

      {_addonsContent(service.Addons.filter((a) => a.available))}

    </div>
  )

}
